// ============================================
// Creator Autofill - Modal (ES6)
// 자동채우기 모달 UI
// ============================================

import { showGlobalLoading, hideGlobalLoading } from '../../utils.js';
import { getCurrentUser } from '../../app/state.js';
import {
  getAutofillTagsCache, setAutofillTagsCache,
  getImageModelList,
  isCacheValid
} from '../state.js';
import { loadImageModelsData } from '../image-gallery.js';
import {
  renderModelCarousel,
  selectModelInCarousel,
  createTagChipsHTML,
  toggleImageOptionSection,
  calculateAutofillCost,
  updateCostDisplay,
  switchAutofillTabGeneric,
  openAutofillModalGeneric,
  closeAutofillModalGeneric,
  loadAutofillTagsFromFirestore
} from '../../shared/autofill-utils.js';
import { initFullGenTagChips, renderFullGenModelCarousel, updateFullGenCost, handleFullGenModeChange, toggleFullGenImageOption } from './full-generate.js';

// ============================================
// 태그 로드
// ============================================

export async function loadAutofillTags() {
  const cached = getAutofillTagsCache();
  if (cached) return cached;

  const tagsData = await loadAutofillTagsFromFirestore();
  setAutofillTagsCache(tagsData);
  return tagsData;
}

async function initAutofillTagChips() {
  const container = document.getElementById('autofillGenreChips');
  const hiddenInput = document.getElementById('autofillSelectedGenres');
  if (!container) return;

  const tagsData = await loadAutofillTags();
  const tags = tagsData.tags || [];

  container.innerHTML = createTagChipsHTML(tags, 'CreatorModule', 'selectAutofillGenre');

  if (hiddenInput) hiddenInput.value = '[]';

  const chips = container.querySelectorAll('.autofill-tag-chip');
  chips.forEach(chip => {
    chip.onclick = () => {
      const isNone = chip.dataset.genre === '';

      if (isNone) {
        chips.forEach(c => c.classList.remove('selected'));
        chip.classList.add('selected');
      } else {
        chips[0]?.classList.remove('selected');
        chip.classList.toggle('selected');

        const hasSelection = [...chips].some(c => c.classList.contains('selected'));
        if (!hasSelection) {
          chips[0]?.classList.add('selected');
        }
      }

      const selectedTags = [...chips]
        .filter(c => c.classList.contains('selected') && c.dataset.genre)
        .map(c => c.dataset.genre);
      if (hiddenInput) hiddenInput.value = JSON.stringify(selectedTags);
    };
  });
}

// ============================================
// 모델 캐러셀
// ============================================

function renderAutofillModelCarousel() {
  const imageModelList = getImageModelList();
  const selectedModel = document.getElementById('autofillSelectedModel')?.value || imageModelList[0]?.id || '';

  renderModelCarousel(
    'autofillModelCarousel',
    imageModelList,
    selectedModel,
    'CreatorModule',
    'selectAutofillModel',
    'id',
    'image'
  );

  const input = document.getElementById('autofillSelectedModel');
  if (input && !input.value && imageModelList.length > 0) {
    input.value = imageModelList[0].id;
  }

  updateAutofillCost();
}

export function selectAutofillModel(modelId) {
  selectModelInCarousel('autofillModelCarousel', modelId, 'autofillSelectedModel');
  updateAutofillCost();
}

export function updateAutofillCost() {
  const checkbox = document.getElementById('autofillAutoImage');
  const needsImage = checkbox?.checked || false;
  const selectedModelId = document.getElementById('autofillSelectedModel')?.value || '';

  const cost = calculateAutofillCost(5, needsImage, selectedModelId, getImageModelList(), 'id', 1);
  updateCostDisplay('autofillCost', cost);
}

// ============================================
// 옵션 토글
// ============================================

export function toggleAutofillImageOption() {
  toggleImageOptionSection('autofillAutoImage', 'autofillImageModelSection');
  updateAutofillCost();
}

export function toggleAutofillTagOption() {
  const checkbox = document.getElementById('autofillTagToggle');
  const section = document.getElementById('autofillTagSection');
  if (checkbox && section) {
    if (checkbox.checked) {
      section.style.display = 'block';
    } else {
      section.style.display = 'none';
      const genresInput = document.getElementById('autofillSelectedGenres');
      if (genresInput) genresInput.value = '[]';
      document.querySelectorAll('#autofillGenreChips .autofill-tag-chip').forEach(chip => {
        chip.classList.remove('selected');
        if (chip.dataset.genre === '') {
          chip.classList.add('selected');
        }
      });
    }
  }
}

// ============================================
// 탭 전환
// ============================================

export function switchAutofillTab(tabId) {
  switchAutofillTabGeneric('#autofillConfirmModal', tabId, 'charAutofillTabFill', 'charAutofillTabGenerate');
}

// ============================================
// 모달 열기/닫기
// ============================================

export async function autoFillScenario() {
  if (!getCurrentUser()) {
    const { showToast } = await import('../../utils.js');
    showToast('로그인이 필요합니다');
    return;
  }

  const modal = document.getElementById('autofillConfirmModal');
  if (!modal) return;

  const needsModelLoad = getImageModelList().length === 0 && !isCacheValid('imageModels');

  if (needsModelLoad) {
    showGlobalLoading();
    const loadingEl = document.querySelector('.global-loading-text');
    if (loadingEl) loadingEl.textContent = '모델 불러오는 중...';

    try {
      await loadImageModelsData();
    } catch (error) {
      console.error('모델 로드 실패:', error);
    } finally {
      hideGlobalLoading();
    }
  }

  renderAutofillModelCarousel();
  openAutofillModalGeneric('autofillConfirmModal');

  document.getElementById('autofillAutoImage').checked = true;
  toggleAutofillImageOption();

  initAutofillTagChips();

  initFullGenTagChips();
  renderFullGenModelCarousel();
  document.getElementById('charFullGenAutoImage').checked = true;
  toggleFullGenImageOption();
  // 라디오 버튼으로 설명 모드를 기본값으로 설정
  const descRadio = document.querySelector('input[name="charFullGenMode"][value="description"]');
  if (descRadio) descRadio.checked = true;
  handleFullGenModeChange();
  updateFullGenCost();

  switchAutofillTab('fill');
}

export function closeAutofillModal() {
  closeAutofillModalGeneric('autofillConfirmModal');
}
